import type {Filter} from 'src/typings';
import type {FiltersDataService} from './filters.data-service';

export class KpFiltersPresenter {
    public static presenterName = 'kpFiltersPresenter';

    /*@ngInject*/
    constructor(private filtersDataService: FiltersDataService) {
    }

    public async getFilters(): Promise<Filter[]> {
        return this.filtersDataService.getAll();
    }


}